/** @format */
// HeaderCategories.jsx
import { useEffect, useRef } from "react";
import { FaList } from "react-icons/fa";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";
import { useNavigate } from "react-router-dom";

const HeaderCategories = ({ t, categories, categoryShow, setCategoryShow }) => {
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setCategoryShow(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [setCategoryShow]);

  return (
    <div className='w-3/12 md-lg:w-full' ref={dropdownRef}>
      <div className='relative'>
        {/* Trigger Button */}
        <button
          onClick={() => setCategoryShow(!categoryShow)}
          className='w-full h-[52px] flex items-center justify-between px-5
                     bg-blue-600 hover:bg-blue-700 active:bg-blue-800
                     text-white rounded-md
                     shadow-[0_4px_14px_rgba(37,99,235,0.35)]
                     hover:shadow-[0_6px_20px_rgba(37,99,235,0.45)]
                     transition-all duration-200 ease-in-out
                     cursor-pointer select-none group'
        >
          <div className='flex items-center gap-3'>
            <FaList className='text-base opacity-90' />
            <span className='text-sm font-bold tracking-wide'>
              {t("All Categories")}
            </span>
          </div>
          <MdOutlineKeyboardArrowDown
            className={`text-xl transition-transform duration-300 ease-in-out ${
              categoryShow ? "rotate-180" : "rotate-0"
            }`}
          />
        </button>

        {/* Dropdown Panel */}
        <div
          className={`
            absolute top-[calc(100%+8px)] left-0 w-full z-[99998]
            bg-white rounded-md
            border border-slate-100
            shadow-[0_8px_40px_rgba(0,0,0,0.13)]
            overflow-hidden
            transition-all duration-300 ease-in-out
            origin-top
            md-lg:relative md-lg:top-0 md-lg:mt-2
            ${
              categoryShow
                ? "opacity-100 scale-y-100 max-h-[400px] pointer-events-auto"
                : "opacity-0 scale-y-95 max-h-0 pointer-events-none"
            }
          `}
          style={{ transformOrigin: "top center" }}
        >
          <ul className='py-2 overflow-y-auto max-h-[400px] divide-y divide-slate-50'>
            {categories.map((category, index) => (
              <li key={index}>
                <div
                  onClick={() => {
                    setCategoryShow(false);
                    navigate(`/products?category=${category.name}`);
                  }}
                  className='flex items-center gap-3 px-4 py-[10px]
                             cursor-pointer group/item
                             hover:bg-blue-50
                             transition-colors duration-150 ease-in-out'
                >
                  {/* Category Image */}
                  <div
                    className='shrink-0 w-8 h-8 rounded-md overflow-hidden bg-slate-100
                                  ring-1 ring-slate-200 group-hover/item:ring-blue-200
                                  transition-all duration-150'
                  >
                    <img
                      src={category.image?.url || category.image}
                      alt={category.name}
                      className='w-full h-full object-cover'
                    />
                  </div>

                  {/* Category Name */}
                  <span
                    className='text-sm font-medium text-slate-600
                               group-hover/item:text-blue-600
                               transition-colors duration-150 truncate'
                  >
                    {category.name}
                  </span>

                  {/* Arrow indicator */}
                  <svg
                    className='ml-auto shrink-0 w-3.5 h-3.5 text-slate-300
                               group-hover/item:text-blue-400
                               translate-x-0 group-hover/item:translate-x-0.5
                               transition-all duration-150'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='currentColor'
                    strokeWidth='2.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  >
                    <polyline points='9 18 15 12 9 6' />
                  </svg>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default HeaderCategories;
